import {
	TSelectedItem,
	TActiveItemToDisplay,
	TNotificationsForCategory,
	TTypeOfModalWindow,
	IIDsSelectedItems,
	IDishesWithAdditionalProperty,
	TDishesSortBy,
} from './dishAssignmentContext';
import {
	IItemForGetShortInfo,
	IDishesForAssign,
	IDataGetCategoriesByIDRestaurantForAssignDishes,
	IDataGetSubcategoriesByIDsCategoriesForAssignDishes,
} from 'types';

export enum DishAssignmentActionTypes {
	SET_DISHES_FOR_ASSIGN = 'SET_DISHES_FOR_ASSIGN',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	CHANGE_SEARCH_STRING_FOR_CATEGORIES = 'CHANGE_SEARCH_STRING_FOR_CATEGORIES',
	CHANGE_SEARCH_STRING_FOR_SUBCATEGORIES = 'CHANGE_SEARCH_STRING_FOR_SUBCATEGORIES',
	CHANGE_SEARCH_STRING_FOR_DISHES = 'CHANGE_SEARCH_STRING_FOR_DISHES',
	SET_ID_SELECTED_CUSTOMER = 'SET_ID_SELECTED_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_ID_SELECTED_RESTAURANT = 'SET_ID_SELECTED_RESTAURANT',
	SET_PRICE = 'SET_PRICE',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	CHANGE_UNASSIGNED_DISHES_STATUS = 'CHANGE_UNASSIGNED_DISHES_STATUS',
	SET_SORT_BY = 'SET_SORT_BY',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_IDS_SELECTED_DISHES = 'SET_IDS_SELECTED_DISHES',
	SET_CATEGORIES = 'SET_CATEGORIES',
	SET_IDS_SELECTED_CATEGORIES = 'SET_IDS_SELECTED_CATEGORIES',
	SET_IDS_SELECTED_SUBCATEGORIES = 'SET_IDS_SELECTED_SUBCATEGORIES',
	SET_DISHES = 'SET_DISHES',
	CHANGE_IS_SHOW_MODAL_WINDOW_TO_CREATE_SUBCATEGORY = 'CHANGE_IS_SHOW_MODAL_WINDOW_TO_CREATE_SUBCATEGORY',
	CHANGE_ACTIVE_ITEM_TO_DISPLAY = 'CHANGE_ACTIVE_ITEM_TO_DISPLAY',
	TOGGLE_SHOW_BREADCRUMBS = 'TOGGLE_SHOW_BREADCRUMBS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_CHANGES = 'RESET_CHANGES',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	CHANGE_SELECT_SEARCH_STRING = 'CHANGE_SELECT_SEARCH_STRING',
}

interface ISetDishesForAssign {
	type: DishAssignmentActionTypes.SET_DISHES_FOR_ASSIGN;
	payload: {
		dishesForAssign: IDishesForAssign;
	};
}

interface IChangeSearchString {
	type: DishAssignmentActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface IChangeSearchStringForCategories {
	type: DishAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_CATEGORIES;
	payload: {
		searchStringForCategories: string;
	};
}

interface IChangeSearchStringForSubcategories {
	type: DishAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_SUBCATEGORIES;
	payload: {
		searchStringForSubcategories: string;
	};
}

interface IChangeSearchStringForDishes {
	type: DishAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_DISHES;
	payload: {
		searchStringForDishes: string;
	};
}

interface ISetIDSelectedCustomer {
	type: DishAssignmentActionTypes.SET_ID_SELECTED_CUSTOMER;
	payload: {
		IDSelectedCustomer: TSelectedItem;
	};
}

interface ISetFetchedRestaurants {
	type: DishAssignmentActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetIDSelectedRestaurant {
	type: DishAssignmentActionTypes.SET_ID_SELECTED_RESTAURANT;
	payload: {
		IDSelectedRestaurant: TSelectedItem;
	};
}

interface ISetPrice {
	type: DishAssignmentActionTypes.SET_PRICE;
	payload: {
		price: string;
	};
}

interface IResetSelectedControls {
	type: DishAssignmentActionTypes.RESET_SELECTED_CONTROLS;
}

interface IChangeIsUnassignedDishesStatus {
	type: DishAssignmentActionTypes.CHANGE_UNASSIGNED_DISHES_STATUS;
	payload: {
		isUnassignedDishes: boolean;
	};
}

interface ISetSortBy {
	type: DishAssignmentActionTypes.SET_SORT_BY;
	payload: {
		sortBy: TDishesSortBy;
	};
}

interface IChangeCurrentPage {
	type: DishAssignmentActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

interface ISetIDsSelectedDishes {
	type: DishAssignmentActionTypes.SET_IDS_SELECTED_DISHES;
	payload: {
		IDsSelectedDishes: string[];
	};
}

interface ISetCategories {
	type: DishAssignmentActionTypes.SET_CATEGORIES;
	payload: {
		categories: IDataGetCategoriesByIDRestaurantForAssignDishes[];
		notificationsForCategory: TNotificationsForCategory;
	};
}

interface ISetIDsSelectedCategories {
	type: DishAssignmentActionTypes.SET_IDS_SELECTED_CATEGORIES;
	payload: {
		IDsSelectedCategories: IIDsSelectedItems;
		subcategories: IDataGetSubcategoriesByIDsCategoriesForAssignDishes[];
		IDsSelectedSubcategories: IIDsSelectedItems;
		dishes: IDishesWithAdditionalProperty[];
	};
}

interface ISetIDsSelectedSubcategories {
	type: DishAssignmentActionTypes.SET_IDS_SELECTED_SUBCATEGORIES;
	payload: {
		IDsSelectedSubcategories: IIDsSelectedItems;
		dishes: IDishesWithAdditionalProperty[];
	};
}

interface ISetDishes {
	type: DishAssignmentActionTypes.SET_DISHES;
	payload: {
		dishes: IDishesWithAdditionalProperty[];
		IDsSelectedDishes: string[];
	};
}

interface IChangeIsShowModalWindowToCreateSubcategory {
	type: DishAssignmentActionTypes.CHANGE_IS_SHOW_MODAL_WINDOW_TO_CREATE_SUBCATEGORY;
	payload: {
		isShowModalWindowToCreateSubcategory: boolean;
	};
}

interface IResetChanges {
	type: DishAssignmentActionTypes.RESET_CHANGES;
}

interface IChangeActiveItemToDisplay {
	type: DishAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY;
	payload: {
		activeItemToDisplay: TActiveItemToDisplay;
	};
}

interface ISetShowBreadcrumbs {
	type: DishAssignmentActionTypes.TOGGLE_SHOW_BREADCRUMBS;
	payload: {
		isShowBreadCrumbs: boolean;
	};
}

interface IChangeTypeOfModalWindow {
	type: DishAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: DishAssignmentActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisible: boolean;
	};
}

interface IToggleApplyToOne {
	type: DishAssignmentActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: DishAssignmentActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		additionalRestaurants: string[];
	};
}

interface IChangeSelectSearchString {
	type: DishAssignmentActionTypes.CHANGE_SELECT_SEARCH_STRING;
	payload: {
		selectSearchString: string;
	};
}

export type TDishAssignmentAction =
	| ISetDishesForAssign
	| IChangeSearchString
	| IChangeSearchStringForCategories
	| IChangeSearchStringForSubcategories
	| IChangeSearchStringForDishes
	| ISetIDSelectedCustomer
	| ISetFetchedRestaurants
	| ISetIDSelectedRestaurant
	| ISetPrice
	| IResetSelectedControls
	| IChangeIsUnassignedDishesStatus
	| ISetSortBy
	| IChangeCurrentPage
	| ISetIDsSelectedDishes
	| ISetCategories
	| IChangeActiveItemToDisplay
	| ISetShowBreadcrumbs
	| ISetIDsSelectedCategories
	| ISetIDsSelectedSubcategories
	| ISetDishes
	| IChangeIsShowModalWindowToCreateSubcategory
	| IChangeTypeOfModalWindow
	| IResetChanges
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| IChangeSelectSearchString;
